<template>
  <div>

    <div v-if="!success">


      <div class="field">
        <div class="control" :class="{'is-loading': isLoading}">
          <input class="input" v-model="code" type="text" placeholder="Input your redeem code">
        </div>
      </div>
      <div class="control" style="margin-bottom: 20px;">
        <button class="button is-info" v-on:click="submit">
          Check Code
        </button>
      </div>
      <p class="has-text-danger" v-if="evMessage">{{ evMessage }}</p>
      <p class="has-text-danger" v-if="message">{{ message }}</p>
    </div>
    <form v-if="success" :action="submitUrl" method="POST">

      <input name="code" :value="code" type="hidden">
      <input type="hidden" name="_token" :value="csrf">

      <button class="button is-success" v-on:click="submit">
        Get your ticket now!
      </button>
      <br>
      <p>Success: click to get your ticket</p>
    </form>

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RedeemTicket",
  computed: {},
  props:
      {
        url: {
          type: String,
          required: true
        },
        submitUrl: {
          type: String,
          required: true
        },

      },

  data() {
    return {
      code: '',
      message: '',
      evMessage: '',
      success: false,
      isLoading: false,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },

  methods: {


    submit() {

      if (!this.code) {
        this.message = 'You must enter a code';
        return;
      }

      this.message = '';
      this.evMessage = '';
      this.isLoading = true;



      const formData = new FormData();
      formData.append('code', this.code);
      //console.log(formData);

      // https://github.com/axios/axios/issues/960
      // https://stackoverflow.com/questions/51143730/axios-posting-empty-request
      axios.post(this.url, formData)
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            //console.log(response.data);
            this.message = '';
            this.success = true;
            this.isLoading = false;
          })
          .catch(error => {

            this.isLoading = false;

            if (error.response) {
              this.message = error.response.data.message;
              if (error.response.status !== 401) {
                this.evMessage = 'An error has occurred. This is not an Eventzilla error. ';
                if (this.message) {
                  this.evMessage += 'Details are as follows:'
                } else {
                  this.evMessage += 'There are no details about this error. You should contact the conference organizers.';
                }
              } else {
                this.message = this.message ? this.message : 'It seems that this code is invalid.';
              }
            } else {
              this.evMessage = 'An error has occurred. This is not an Eventzilla error. ' +
                  'It is most likely caused by your browser/institution blocking the connection.' +
                  '(1) Try in a different browser or computer - even your mobile. ' +
                  '(2) Try in a different location. ' +
                  'Failing that you should contact the conference organizers.';
            }

          });

    },

  },

  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  }


};
</script>

<style scoped>
i {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}
</style>